export const otp = {
    title: 'Security Verification',
    label: 'Email Verification Code',
    content: 'Enter the 6-digit code ',
    button: 'Confirm',
    backToLogin: 'Back to login',
    receivedCode: "You haven't received the code yet? Request a new code later ",
    seconds: '{seconds} seconds',
    receivedCodeYet: "You haven't received the code yet?",
    resendCode: 'Resend code',
};
